import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { AutomapperService } from "../../../../core/automapper/automapper.service";
import { BASE_API_URL } from "../../../../core/environment.tokens";
import { AuditPackageStatus } from "../audit-package-status.enum";
import { ChaseDetailForAuditItem } from "../chase-detail-for-audit-item.model";
import { AuditPackage } from "../models/audit-package.model";

@Injectable({
  providedIn: "root",
})
export class AuditPackageService {
  constructor(
    @Inject(BASE_API_URL)
    private readonly baseApiUrl: string,
    private http: HttpClient,
    private automapper: AutomapperService
  ) { }

  createOrGetAuditPackage(chaseAuditData: ChaseDetailForAuditItem): Observable<number> {
    const url = `${this.baseApiUrl}audit/updatechaseauditdata`;


    return this.http.post(url, chaseAuditData.toApiRequest())
      .pipe(map((response: any) => response as number));
  }

  getActiveAuditPackageForMember(memberId: number): Observable<AuditPackage[]> {
    const url = `${this.baseApiUrl}audit/auditpackages`;

    const requestData = {
      MemberId: memberId,
      Status: AuditPackageStatus.ACTIVE,
    };

    return this.http.post(url, requestData)
      .pipe(map((response: any) => {
        if (Array.isArray(response)) {
          return response.map((item: any) => {
            try {
              return this.automapper.map("default", "AuditPackage", item);
            } catch (error) {
              console.error("Error mapping audit package:", error, item);
              return null;
            }
          }).filter(item => item !== null);
        } else {
          return [];
        }
      }));
  }

  getAuditPackages(auditPackageSelection: any): Observable<any[]> {
    const url = `${this.baseApiUrl}audit/auditpackages`;

    return this.http.post(url, auditPackageSelection)
      .pipe(map((response: any) => response));
  }

  getAuditPackagesCount(enrollee: number): Observable<number> {
    const url = `${this.baseApiUrl}audit/auditpackagesCount?memberId=${enrollee}&status=${AuditPackageStatus.COMPLETED}`;
    return this.http.get(url) as Observable<number>;
  }
}
